import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "product-associations"
};
const _hoisted_2 = { class: "data-item__section-title" };
const _hoisted_3 = { class: "product-associations__productsValue" };
const _hoisted_4 = { class: "product-card__content" };
const _hoisted_5 = { class: "product-card__category" };
const _hoisted_6 = { class: "product-card__name" };
const _hoisted_7 = { class: "product-card__image" };
const _hoisted_8 = ["src"];
import { onMounted, ref } from 'vue';
import products from '@astina/paloma-shop-common-ui/src/services/ProductRepository';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProductAssociations',
    props: {
        association: {},
        itemNumbers: {}
    },
    setup(__props) {
        const props = __props;
        const productsValue = ref([]);
        const more = ref(false);
        onMounted(() => {
            products
                .list({
                query: null,
                filters: [{
                        attribute: 'itemNumber',
                        values: props.itemNumbers,
                    }],
            }, {
                number: 0,
                size: 10,
            }, [])
                .then((data) => {
                productsValue.value = data.content;
                more.value = data.totalPages > 1;
            });
        });
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (productsValue.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.$t('product.associations.' + __props.association)), 1),
                    _cache[2] || (_cache[2] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_3, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productsValue.value, (product) => {
                            return (_openBlock(), _createBlock(_component_router_link, {
                                to: { name: 'catalog_category_product', params: { id: product.id } },
                                key: product.id,
                                class: "product-card"
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_4, [
                                        _createElementVNode("div", _hoisted_5, _toDisplayString(product.topic), 1),
                                        _cache[0] || (_cache[0] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_6, _toDisplayString(product.title), 1)
                                    ]),
                                    _cache[1] || (_cache[1] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_7, [
                                        (product.attributes['_main_image'])
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 0,
                                                src: product.attributes['_main_image']
                                            }, null, 8, _hoisted_8))
                                            : _createCommentVNode("", true)
                                    ])
                                ]),
                                _: 2
                            }, 1032, ["to"]));
                        }), 128))
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
